import { RecruitmentStatus } from "~/api/_common/types-for-recruitment"

import { Company, CreateCompanyArgs } from "./Company"

export interface createLongInternshipArgs {
  id: number
  title: string
  job_type: string
  content: string
  thumbnail_img_url: string
  status: RecruitmentStatus
  url: string
  created_at: string
  company: CreateCompanyArgs
}

export class LongInternship {
  id: number
  title: string
  jobType: string
  content: string
  thumbnailImgUrl: string
  status: RecruitmentStatus
  url: string
  createdAt: string
  company: Company

  constructor(args: createLongInternshipArgs) {
    this.id = args.id
    this.title = args.title
    this.jobType = args.job_type
    this.content = args.content
    this.thumbnailImgUrl = args.thumbnail_img_url
    this.status = args.status
    this.url = args.url || ""
    this.createdAt = args.created_at
    this.company = new Company(args.company as any)
  }
}
